import React, { useState, useEffect } from "react";
import axios from "./axiosConfig";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { useConfirm } from '../context/ConfirmContext';

// Variantes de animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

function Publicaciones() {
  const { canCreateEdit, isSuperAdmin } = useAuth();
  const { confirm } = useConfirm();
  const [publicaciones, setPublicaciones] = useState([]);
  const [totalPublicaciones, setTotalPublicaciones] = useState(0);
  const [investigadores, setInvestigadores] = useState([]);
  const [universidades, setUniversidades] = useState([]);
  const [newPublicacion, setNewPublicacion] = useState({
    titulo: "",
    anio: "",
    tipo: "",
    journal: "",
    publisher: "",
    volume: "",
    issue: "",
    citations_count: "",
    keywords: "",
    abstract: "",
    doi: "",
    is_open_access: false,
    oa_status: "",
    language: "",
    investigador_id: "",
  });
  const [filters, setFilters] = useState({
    universidad_id: '',
    year_from: '',
    year_to: '',
    title: '',
    tipo: '',
    keyword: '',
    open_access: '',
    cuartil: '',
  });
  const [error, setError] = useState(null);
  const [showFormModal, setShowFormModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [showKeywordsModal, setShowKeywordsModal] = useState(false);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedPublication, setSelectedPublication] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [refreshingPublicationId, setRefreshingPublicationId] = useState(null);
  const [refreshingBulk, setRefreshingBulk] = useState(false);
  const [refreshJob, setRefreshJob] = useState(null);
  const [odsAnalysisByPublicationId, setOdsAnalysisByPublicationId] = useState({});
  const [analyzingOdsPublicationId, setAnalyzingOdsPublicationId] = useState(null);

  useEffect(() => {
    fetchPublicacionesPage(1);
    fetchUniversidades();
  }, []);

  useEffect(() => {
    if (currentPage !== 1) {
      fetchPublicacionesPage(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    if (showFormModal && investigadores.length === 0) {
      fetchInvestigadores();
    }
  }, [showFormModal]);

  useEffect(() => {
    if (!refreshJob?.job_id) return undefined;
    if (!['PENDING', 'RUNNING'].includes(refreshJob.status)) return undefined;

    const intervalId = setInterval(async () => {
      try {
        const response = await axios.get(`/api/publicaciones/refresh-jobs/${refreshJob.job_id}`);
        const job = response.data;
        setRefreshJob(job);
        if (!['PENDING', 'RUNNING'].includes(job.status)) {
          await fetchPublicacionesPage(currentPage);
          setRefreshingBulk(false);
          setSuccessMessage(
            job.status === 'COMPLETED_WITH_ERRORS'
              ? `Job completado con observaciones. Actualizadas: ${job.updated_count}, omitidas: ${job.skipped_count}, errores: ${job.error_count}.`
              : `Job completado. Actualizadas: ${job.updated_count}, omitidas: ${job.skipped_count}.`
          );
        }
      } catch (error) {
        setRefreshingBulk(false);
        setError(error.response?.data?.detail || ('Error consultando el progreso del job: ' + error.message));
      }
    }, 3000);

    return () => clearInterval(intervalId);
  }, [refreshJob?.job_id, refreshJob?.status, currentPage]);

  useEffect(() => {
    if (!showDetailModal || !selectedPublication?.id || !canCreateEdit()) return undefined;
    if (odsAnalysisByPublicationId[selectedPublication.id]) return undefined;
    loadOdsAnalysis(selectedPublication.id);
    return undefined;
  }, [showDetailModal, selectedPublication?.id]);

  const fetchPublicaciones = async (page = currentPage) => {
    try {
      setLoading(true);
      const params = {};
      if (filters.year_from) params.year_from = filters.year_from;
      if (filters.year_to) params.year_to = filters.year_to;
      if (filters.title) params.title = filters.title;
      if (filters.tipo) params.tipo = filters.tipo;
      if (filters.keyword) params.keyword = filters.keyword;
      if (filters.open_access !== '') params.open_access = filters.open_access;
      if (filters.cuartil) params.cuartil = filters.cuartil;
      // Traer mÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡s de 100 (backend por defecto limita a 100)
      params.skip = (page - 1) * itemsPerPage;
      params.limit = itemsPerPage;
      const response = await axios.get("/api/publicaciones/paged", { params });
      if (Array.isArray(response.data?.items)) {
        setPublicaciones(response.data.items);
        setTotalPublicaciones(Number(response.data?.total || 0));
        setError(null);
      } else {
        setPublicaciones([]);
        setError("La respuesta del servidor no es una lista valida");
      }
    } catch (error) {
      setPublicaciones([]);
      setError("Error al obtener publicaciones: " + error.message);
      console.error("Error fetching publicaciones:", error);
    }
  };

  const fetchInvestigadores = async () => {
    try {
      const response = await axios.get("/api/investigadores/");
      if (Array.isArray(response.data)) {
        setInvestigadores(response.data);
        setError(null);
      } else {
        setInvestigadores([]);
        setError("La respuesta del servidor no es una lista valida para investigadores");
      }
    } catch (error) {
      setInvestigadores([]);
      setError("Error al obtener investigadores: " + error.message);
      console.error("Error fetching investigadores:", error);
    }
  };

  const fetchUniversidades = async () => {
    try {
      const response = await axios.get("/api/universities");
      setUniversidades(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setUniversidades([]);
      console.error("Error fetching universidades:", error);
    }
  };

  const fetchPublicacionesPage = async (page = currentPage) => {
    try {
      setLoading(true);
      const params = {};
      if (filters.year_from) params.year_from = filters.year_from;
      if (filters.year_to) params.year_to = filters.year_to;
      if (filters.title) params.title = filters.title;
      if (filters.tipo) params.tipo = filters.tipo;
      if (filters.keyword) params.keyword = filters.keyword;
      if (filters.open_access !== '') params.open_access = filters.open_access;
      if (filters.cuartil) params.cuartil = filters.cuartil;
      if (filters.universidad_id) params.universidad_id = filters.universidad_id;
      params.skip = (page - 1) * itemsPerPage;
      params.limit = itemsPerPage;

      const response = await axios.get("/api/publicaciones/paged", { params });
      if (Array.isArray(response.data?.items)) {
        setPublicaciones(response.data.items);
        setTotalPublicaciones(Number(response.data?.total || 0));
        setError(null);
      } else {
        setPublicaciones([]);
        setTotalPublicaciones(0);
        setError("La respuesta del servidor no es una lista valida");
      }
    } catch (error) {
      setPublicaciones([]);
      setTotalPublicaciones(0);
      setError("Error al obtener publicaciones: " + error.message);
      console.error("Error fetching publicaciones paged:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const applyFilters = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchPublicacionesPage(1);
  };

  const clearFilters = () => {
    setFilters({
      universidad_id: '',
      year_from: '',
      year_to: '',
      title: '',
      tipo: '',
      keyword: '',
      open_access: '',
      cuartil: '',
    });
    setCurrentPage(1);
    setTimeout(() => fetchPublicacionesPage(1), 0);
  };

  const handleInputChange = (e) => {
    setNewPublicacion({ ...newPublicacion, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const publicacionData = {
        titulo: newPublicacion.titulo,
        anio: newPublicacion.anio ? parseInt(newPublicacion.anio) : null,
        tipo: newPublicacion.tipo || null,
        journal: newPublicacion.journal || null,
        publisher: newPublicacion.publisher || null,
        volume: newPublicacion.volume || null,
        issue: newPublicacion.issue || null,
        citations_count: newPublicacion.citations_count ? parseInt(newPublicacion.citations_count) : 0,
        keywords: newPublicacion.keywords ? newPublicacion.keywords.split(",").map((k) => k.trim()) : null,
        abstract: newPublicacion.abstract || null,
        doi: newPublicacion.doi || null,
        is_open_access: newPublicacion.is_open_access || false,
        oa_status: newPublicacion.oa_status || null,
        language: newPublicacion.language || null,
        source: "manual",
        investigador_id: newPublicacion.investigador_id
          ? parseInt(newPublicacion.investigador_id, 10)
          : null,
      };
      if (isEditing) {
        await axios.put(`/api/publicaciones/${editId}`, publicacionData);
      } else {
        await axios.post("/api/publicaciones/", publicacionData);
      }
      fetchPublicacionesPage(currentPage);
      resetForm();
      setShowFormModal(false);
      setError(null);
      setSuccessMessage(isEditing ? "La publicacion se actualizo correctamente." : "La publicacion se creo correctamente.");
    } catch (error) {
      let errorMsg = '';
      
      // Manejar errores de validaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de FastAPI/Pydantic
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        if (Array.isArray(detail)) {
          // Error de validaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n Pydantic (array de errores)
          errorMsg = detail.map(err => {
            if (typeof err === 'object' && err.msg) {
              const field = err.loc ? err.loc[err.loc.length - 1] : 'campo';
              return `${field}: ${err.msg}`;
            }
            return String(err);
          }).join('; ');
        } else if (typeof detail === 'object') {
          errorMsg = JSON.stringify(detail);
        } else {
          errorMsg = String(detail);
        }
      } else {
        errorMsg = error.message;
      }
      
      setError(
        `Error al ${isEditing ? "actualizar" : "agregar"} publicacion: ` + errorMsg
      );
    }
  };

  const handleEdit = (pub) => {
    setNewPublicacion({
      titulo: pub.titulo || "",
      anio: pub.anio || "",
      tipo: pub.tipo || "",
      journal: pub.journal || "",
      publisher: pub.publisher || "",
      volume: pub.volume || "",
      issue: pub.issue || "",
      citations_count: pub.citations_count || "",
      keywords: pub.keywords ? pub.keywords.join(", ") : "",
      abstract: pub.abstract || "",
      doi: pub.doi || "",
      is_open_access: pub.is_open_access || false,
      oa_status: pub.oa_status || "",
      language: pub.language || "",
      investigador_id: pub.investigador_id || "",
    });
    setEditId(pub.id);
    setIsEditing(true);
    setShowFormModal(true);
  };

  const handleDelete = async (id) => {
    const accepted = await confirm({
      title: 'Eliminar publicacion',
      message: 'Estas seguro de eliminar esta publicacion?',
      details: 'La publicacion se quitara del listado y esta accion no se puede deshacer.',
      confirmText: 'Si, eliminar',
      cancelText: 'Cancelar',
      variation: 'danger',
      badge: 'Eliminar',
      icon: 'delete',
    });
    if (!accepted) return;

    try {
      await axios.delete(`/api/publicaciones/${id}`);
      fetchPublicacionesPage(currentPage);
      setError(null);
      setSuccessMessage('La publicacion se elimino correctamente.');
    } catch (error) {
      setError('Error al eliminar publicacion: ' + error.message);
    }
  };

  const handleRefreshPublication = async (pub) => {
    const accepted = await confirm({
      title: 'Actualizar metadatos',
      message: 'Se consultara OpenAlex para refrescar citas y metadatos dinamicos de esta publicacion.',
      details: 'Esto puede actualizar citas, autores, topics, abstract, Open Access y otros campos disponibles en OpenAlex.',
      confirmText: 'Actualizar ahora',
      cancelText: 'Cancelar',
      variation: 'warning',
      badge: 'OpenAlex',
      icon: 'sync',
    });
    if (!accepted) return;

    try {
      setRefreshingPublicationId(pub.id);
      const response = await axios.post(`/api/publicaciones/${pub.id}/refresh`);
      const refreshedPublication = response.data?.publicacion || null;
      await fetchPublicacionesPage(currentPage);
      if (showDetailModal && selectedPublication?.id === pub.id && refreshedPublication) {
        setSelectedPublication(refreshedPublication);
      }
      setError(null);
      setSuccessMessage(response.data?.message || 'La publicacion se actualizo desde OpenAlex.');
    } catch (error) {
      setError(error.response?.data?.detail || ('Error al actualizar metadatos: ' + error.message));
    } finally {
      setRefreshingPublicationId(null);
    }
  };

  async function loadOdsAnalysis(publicationId) {
    try {
      const response = await axios.get(`/api/publicaciones/${publicationId}/ods-analysis`);
      setOdsAnalysisByPublicationId((prev) => ({
        ...prev,
        [publicationId]: response.data,
      }));
      return response.data;
    } catch (error) {
      return null;
    }
  }

  async function handleAnalyzeOds(pub) {
    try {
      setAnalyzingOdsPublicationId(pub.id);
      setSelectedPublication(pub);
      setShowDetailModal(true);
      const response = await axios.post(`/api/publicaciones/${pub.id}/ods-analysis`, null, {
        params: { methods: 'both' },
      });
      setOdsAnalysisByPublicationId((prev) => ({
        ...prev,
        [pub.id]: response.data,
      }));
      setSuccessMessage('Comparacion ODS generada con heuristica e IA.');
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || ('Error al analizar ODS: ' + error.message));
    } finally {
      setAnalyzingOdsPublicationId(null);
    }
  }

  const handleRefreshBulk = async () => {
    const accepted = await confirm({
      title: 'Actualizar publicaciones filtradas',
      message: 'Se consultara OpenAlex para refrescar las publicaciones que coinciden con los filtros actuales.',
      details: 'Se creara un job en segundo plano que recorrera todas las publicaciones filtradas por tandas, con seguimiento de progreso y sin cortar el proceso en las primeras 100.',
      confirmText: 'Actualizar lote',
      cancelText: 'Cancelar',
      variation: 'warning',
      badge: 'Lote',
      icon: 'sync',
    });
    if (!accepted) return;

    try {
      setRefreshingBulk(true);
      const params = {
        max_items: 100,
      };
      if (filters.universidad_id) params.universidad_id = filters.universidad_id;
      if (filters.year_from) params.year_from = filters.year_from;
      if (filters.year_to) params.year_to = filters.year_to;
      if (filters.title) params.title = filters.title;
      if (filters.tipo) params.tipo = filters.tipo;
      if (filters.keyword) params.keyword = filters.keyword;
      if (filters.open_access !== '') params.open_access = filters.open_access;
      if (filters.cuartil) params.cuartil = filters.cuartil;

      const response = await axios.post('/api/publicaciones/refresh-bulk', null, { params });
      const data = response.data || {};
      setError(null);
      setRefreshJob(data);
      setSuccessMessage('Actualizacion masiva iniciada. Puedes seguir trabajando mientras el sistema procesa las publicaciones.');
    } catch (error) {
      setError(error.response?.data?.detail || ("Error al actualizar publicaciones: " + error.message));
    } finally {
      // se mantiene activo hasta que el job termine
    }
  };

  const resetForm = () => {
    setNewPublicacion({
      titulo: "",
      anio: "",
      tipo: "",
      journal: "",
      publisher: "",
      volume: "",
      issue: "",
      citations_count: "",
      keywords: "",
      abstract: "",
      doi: "",
      is_open_access: false,
      oa_status: "",
      language: "",
      investigador_id: "",
    });
    setIsEditing(false);
    setEditId(null);
  };

  // PaginaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â‚¬Å¾Ã‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
  const totalPages = Math.max(1, Math.ceil(totalPublicaciones / itemsPerPage));
  const paginatedPublicaciones = publicaciones;
  const publicationTypeOptions = [
    "article",
    "book",
    "book-chapter",
    "review",
    "editorial",
    "report",
    "preprint",
    "proceedings",
    "conference-paper",
    "thesis",
    "dissertation",
  ];

  return (
    <>

      {/* Header */}
      <motion.header 
        className="bg-surface-light dark:bg-surface-dark shadow-sm border-b border-border-light dark:border-border-dark z-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="max-w-1xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex min-h-16 flex-col justify-center gap-3 py-4 sm:h-16 sm:flex-row sm:items-center sm:justify-between sm:py-0">
            <div className="min-w-0">
              <h2 className="text-xl font-bold leading-7 text-slate-900 dark:text-white sm:truncate">Gestion de Publicaciones</h2>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Administra las publicaciones cientificas de la institucion</p>
            </div>
            <div className="flex w-full items-center sm:w-auto">
              {canCreateEdit() && (
                <motion.button 
                  className="inline-flex w-full items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all sm:w-auto" 
                  type="button"
                  onClick={() => { resetForm(); setShowFormModal(true); }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="material-icons-round text-sm mr-2">add</span>
                  Nueva Publicacion
                </motion.button>
              )}
            </div>
          </div>
        </div>
      </motion.header>

      <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 space-y-6">
        {/* Error Alert */}
        <AnimatePresence>
          {error && (
            <motion.div 
              className="bg-red-50 border border-red-200 rounded-md p-4"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
            >
              <div className="flex">
                <span className="material-icons-round text-red-400 mr-3">error</span>
                <div>
                  <h3 className="text-sm font-medium text-red-800">Error</h3>
                  <div className="text-sm text-red-700 mt-1">{error}</div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {successMessage && (
            <motion.div
              className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
            >
              <div className="flex items-start">
                <span className="material-icons-round mr-3 text-emerald-500">check_circle</span>
                <div className="flex-1">
                  <h3 className="text-sm font-medium text-emerald-800">Proceso completado</h3>
                  <div className="mt-1 text-sm text-emerald-700">{successMessage}</div>
                </div>
                <button
                  type="button"
                  onClick={() => setSuccessMessage(null)}
                  className="ml-3 text-emerald-500 transition-colors hover:text-emerald-700"
                >
                  <span className="material-icons-round text-base">close</span>
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {refreshJob && (
          <motion.div
            className="rounded-2xl border border-[#0f62fe]/20 bg-[#edf4ff] p-4"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-sm font-semibold text-[#0f62fe]">
                  {['PENDING', 'RUNNING'].includes(refreshJob.status)
                    ? 'Actualizacion masiva en progreso'
                    : 'Actualizacion masiva finalizada'}
                </p>
                <p className="text-xs text-slate-600">
                  {['PENDING', 'RUNNING'].includes(refreshJob.status)
                    ? 'El sistema esta refrescando las publicaciones en segundo plano.'
                    : 'El proceso ya termino y el listado refleja los datos mas recientes disponibles.'}
                </p>
                {isSuperAdmin() && (
                  <p className="mt-1 text-[11px] text-slate-500">
                    Job: {refreshJob.job_id} | Estado tecnico: {refreshJob.status}
                  </p>
                )}
              </div>
              <div className="flex flex-wrap items-center gap-3">
                {'processed_count' in refreshJob && (
                  <div className="text-sm text-slate-700">
                    {refreshJob.processed_count || 0} / {refreshJob.total_candidates || 0} procesadas
                  </div>
                )}
                {isSuperAdmin() && (
                  <Link
                    to="/publicaciones-jobs"
                    className="inline-flex items-center rounded-xl border border-[#0f62fe]/20 bg-white px-3 py-2 text-xs font-semibold text-[#0f62fe] transition-colors hover:bg-[#f7fbff]"
                  >
                    Ver panel tecnico
                  </Link>
                )}
              </div>
            </div>
            {'processed_count' in refreshJob && (
              <div className="mt-3">
                <div className="h-2 overflow-hidden rounded-full bg-white/80">
                  <div
                    className="h-full rounded-full bg-[#0f62fe] transition-all duration-500"
                    style={{
                      width: `${refreshJob.total_candidates ? Math.min(100, Math.round(((refreshJob.processed_count || 0) / refreshJob.total_candidates) * 100)) : 0}%`,
                    }}
                  />
                </div>
                <div className="mt-2 flex flex-wrap gap-3 text-xs text-slate-600">
                  <span>Actualizadas: {refreshJob.updated_count || 0}</span>
                  <span>Omitidas: {refreshJob.skipped_count || 0}</span>
                  {(isSuperAdmin() || (refreshJob.error_count || 0) > 0) && (
                    <span>Errores: {refreshJob.error_count || 0}</span>
                  )}
                </div>
                {isSuperAdmin() && Array.isArray(refreshJob.errors) && refreshJob.errors.length > 0 && (
                  <div className="mt-3 rounded-xl border border-slate-200 bg-white/80 p-3 text-xs text-slate-600">
                    <p className="mb-2 font-semibold text-slate-800">Detalle tecnico</p>
                    <ul className="space-y-1">
                      {refreshJob.errors.slice(0, 3).map((errorText, index) => (
                        <li key={`${refreshJob.job_id}-error-${index}`}>{errorText}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </motion.div>
        )}

        {/* Filtros Avanzados */}
        <motion.section 
          className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-sm border border-border-light dark:border-border-dark overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <div className="px-4 py-4 sm:px-6 border-b border-border-light dark:border-border-dark bg-slate-50/50 dark:bg-slate-800/50">
            <h3 className="text-base font-semibold text-slate-900 dark:text-white flex items-center">
              <span className="material-icons-round mr-2 text-primary">tune</span>
              Filtros Avanzados
            </h3>
          </div>
          <div className="p-4 sm:p-6">
            <form onSubmit={applyFilters} className="space-y-4">
              <motion.div 
                className="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-4"
                variants={staggerContainer}
                initial="hidden"
                animate="visible"
              >
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Universidad</label>
                  <select
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="universidad_id"
                    value={filters.universidad_id}
                    onChange={handleFilterChange}
                  >
                    <option value="">Todas las universidades</option>
                    {universidades.map((universidad) => (
                      <option key={universidad.id} value={universidad.id}>
                        {universidad.name || universidad.short_name || universidad.siglas || `Universidad ${universidad.id}`}
                      </option>
                    ))}
                  </select>
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Anio desde</label>
                  <input
                    type="number"
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="year_from"
                    placeholder="2020"
                    value={filters.year_from}
                    onChange={handleFilterChange}
                  />
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Anio hasta</label>
                  <input
                    type="number"
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="year_to"
                    placeholder="2024"
                    value={filters.year_to}
                    onChange={handleFilterChange}
                  />
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Titulo contiene</label>
                  <input
                    type="text"
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="title"
                    placeholder="Buscar por titulo..."
                    value={filters.title}
                    onChange={handleFilterChange}
                  />
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Keyword</label>
                  <input
                    type="text"
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="keyword"
                    placeholder="machine learning..."
                    value={filters.keyword}
                    onChange={handleFilterChange}
                  />
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de publicacion</label>
                  <select
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="tipo"
                    value={filters.tipo}
                    onChange={handleFilterChange}
                  >
                    <option value="">Todos</option>
                    {publicationTypeOptions.map((tipo) => (
                      <option key={tipo} value={tipo}>
                        {tipo}
                      </option>
                    ))}
                  </select>
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Open Access</label>
                  <select
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="open_access"
                    value={filters.open_access}
                    onChange={handleFilterChange}
                  >
                    <option value="">Todos</option>
                    <option value="true">Open Access</option>
                    <option value="false">Acceso Cerrado</option>
                  </select>
                </motion.div>
                <motion.div variants={fadeInUp}>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Cuartil (SJR)</label>
                  <select
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary transition-all"
                    name="cuartil"
                    value={filters.cuartil}
                    onChange={handleFilterChange}
                  >
                    <option value="">Todos</option>
                    <option value="Q1">Q1</option>
                    <option value="Q2">Q2</option>
                    <option value="Q3">Q3</option>
                    <option value="Q4">Q4</option>
                    <option value="sin">Sin cuartil</option>
                  </select>
                </motion.div>
              </motion.div>
              <div className="flex flex-col sm:flex-row gap-3">
                <motion.button 
                  type="submit" 
                  className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="material-icons-round text-sm mr-2">search</span>
                  Aplicar Filtros
                </motion.button>
                <motion.button 
                  type="button" 
                  className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white dark:bg-slate-700 hover:bg-gray-50 dark:hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all"
                  onClick={clearFilters}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="material-icons-round text-sm mr-2">clear</span>
                  Limpiar
                </motion.button>
                {canCreateEdit() && (
                  <motion.button
                    type="button"
                    className="inline-flex items-center justify-center px-4 py-2 border border-[#0f62fe]/20 text-sm font-medium rounded-md text-[#0f62fe] bg-[#edf4ff] hover:bg-[#dbeafe] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0f62fe] transition-all disabled:opacity-60"
                    onClick={handleRefreshBulk}
                    disabled={refreshingBulk}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span className={`material-icons-round text-sm mr-2 ${refreshingBulk ? 'animate-spin' : ''}`}>sync</span>
                    {refreshingBulk ? 'Actualizando...' : 'Actualizar metadatos'}
                  </motion.button>
                )}
              </div>
            </form>
          </div>
        </motion.section>

        {/* Estadisticas */}
        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4"
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >
          <motion.div 
            className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 border border-border-light dark:border-border-dark shadow-sm"
            variants={fadeInUp}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ duration: 0.2 }}
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <motion.div 
                  className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center"
                  whileHover={{ rotate: 10 }}
                >
                  <span className="material-icons-round text-white">article</span>
                </motion.div>
              </div>
              <div className="ml-4">
                <motion.div 
                  className="text-2xl font-bold text-slate-900 dark:text-white"
                  key={totalPublicaciones}
                  initial={{ scale: 1.2 }}
                  animate={{ scale: 1 }}
                >
                  {totalPublicaciones}
                </motion.div>
                <div className="text-xs text-slate-500 dark:text-slate-400">Total publicaciones</div>
              </div>
            </div>
          </motion.div>
          <motion.div 
            className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 border border-border-light dark:border-border-dark shadow-sm"
            variants={fadeInUp}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ duration: 0.2 }}
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <motion.div 
                  className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center"
                  whileHover={{ rotate: 10 }}
                >
                  <span className="material-icons-round text-white">visibility</span>
                </motion.div>
              </div>
              <div className="ml-4">
                <div className="text-2xl font-bold text-slate-900 dark:text-white">{paginatedPublicaciones.length}</div>
                <div className="text-xs text-slate-500 dark:text-slate-400">Mostrando</div>
              </div>
            </div>
          </motion.div>
          <motion.div 
            className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 border border-border-light dark:border-border-dark shadow-sm"
            variants={fadeInUp}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ duration: 0.2 }}
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <motion.div 
                  className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center"
                  whileHover={{ rotate: 10 }}
                >
                  <span className="material-icons-round text-white">layers</span>
                </motion.div>
              </div>
              <div className="ml-4">
                <div className="text-2xl font-bold text-slate-900 dark:text-white">{totalPages}</div>
                <div className="text-xs text-slate-500 dark:text-slate-400">Paginas</div>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Tabla de Publicaciones */}
        <section className="bg-surface-light dark:bg-surface-dark shadow-md rounded-xl border border-border-light dark:border-border-dark overflow-hidden">
          <div className="px-4 py-4 sm:px-6 border-b border-border-light dark:border-border-dark flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between bg-slate-50/50 dark:bg-slate-800/50">
            <h3 className="text-base font-semibold text-slate-900 dark:text-white flex items-center">
              <span className="material-icons-round mr-2 text-slate-500">toc</span>
              Lista de Publicaciones
            </h3>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300">
              {totalPublicaciones} registros
            </span>
            {loading && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                Cargando...
              </span>
            )}
          </div>
          
          {totalPublicaciones === 0 ? (
            <div className="text-center py-12">
              <span className="material-icons-round text-slate-400 text-6xl mb-4">article</span>
              <h3 className="text-lg font-medium text-slate-900 dark:text-white mb-2">No hay publicaciones disponibles</h3>
              <p className="text-slate-500 dark:text-slate-400">Agrega una nueva publicacion para comenzar</p>
            </div>
          ) : (
            <>
              <div className="lg:hidden divide-y divide-border-light dark:divide-border-dark">
                {paginatedPublicaciones.map((pub) => (
                  <article key={pub.id} className="p-4 space-y-3">
                    <div className="flex items-start justify-between gap-3">
                      <button
                        onClick={() => { setSelectedPublication(pub); setShowDetailModal(true); }}
                        className="min-w-0 text-left"
                      >
                        <div className="text-sm font-semibold text-slate-900 dark:text-white line-clamp-2">
                          {pub.titulo}
                        </div>
                      </button>
                    </div>

                    <div className="flex flex-wrap gap-2">
                      {pub.anio && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200">
                          {pub.anio}
                        </span>
                      )}
                      {pub.tipo && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300">
                          {pub.tipo}
                        </span>
                      )}
                      {pub.cuartil && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300">
                          {pub.cuartil}
                        </span>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-3 text-xs">
                      <div className="rounded-lg bg-slate-50 dark:bg-slate-800/60 p-3">
                        <div className="text-slate-500 dark:text-slate-400">Citas</div>
                        <div className="mt-1 font-semibold text-slate-900 dark:text-white">{pub.citations_count || 0}</div>
                      </div>
                      <div className="rounded-lg bg-slate-50 dark:bg-slate-800/60 p-3">
                        <div className="text-slate-500 dark:text-slate-400">Cuartil</div>
                        <div className="mt-1 font-semibold text-slate-900 dark:text-white">{pub.cuartil || '-'}</div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2 pt-1">
                          <button
                            onClick={() => { setSelectedPublication(pub); setShowDetailModal(true); }}
                            className="inline-flex items-center justify-center rounded-md bg-blue-100 px-3 py-2 text-sm font-medium text-blue-700 transition-colors hover:bg-blue-200 dark:bg-blue-900/20 dark:text-blue-300"
                          >
                            Ver
                      </button>
                      {canCreateEdit() && (
                        <>
                          <button
                            onClick={() => handleRefreshPublication(pub)}
                            disabled={refreshingPublicationId === pub.id}
                            className="inline-flex items-center justify-center rounded-md bg-[#edf4ff] px-3 py-2 text-sm font-medium text-[#0f62fe] transition-colors hover:bg-[#dbeafe] disabled:opacity-60 dark:bg-blue-900/20 dark:text-blue-300"
                          >
                            {refreshingPublicationId === pub.id ? 'Actualizando...' : 'Actualizar'}
                          </button>
                          <button
                            onClick={() => handleAnalyzeOds(pub)}
                            disabled={analyzingOdsPublicationId === pub.id}
                            className="inline-flex items-center justify-center rounded-md bg-violet-100 px-3 py-2 text-sm font-medium text-violet-700 transition-colors hover:bg-violet-200 disabled:opacity-60 dark:bg-violet-900/20 dark:text-violet-300"
                          >
                            {analyzingOdsPublicationId === pub.id ? 'Analizando...' : 'Comparar ODS'}
                          </button>
                          <button
                            onClick={() => handleEdit(pub)}
                            className="inline-flex items-center justify-center rounded-md bg-amber-100 px-3 py-2 text-sm font-medium text-amber-700 transition-colors hover:bg-amber-200 dark:bg-amber-900/20 dark:text-amber-300"
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => handleDelete(pub.id)}
                            className="inline-flex items-center justify-center rounded-md bg-rose-100 px-3 py-2 text-sm font-medium text-rose-700 transition-colors hover:bg-rose-200 dark:bg-rose-900/20 dark:text-rose-300"
                          >
                            Eliminar
                          </button>
                        </>
                      )}
                    </div>
                  </article>
                ))}
              </div>

              <div className="hidden lg:block overflow-x-auto">
              <table className="min-w-full divide-y divide-border-light dark:divide-border-dark">
                <thead className="bg-slate-100 dark:bg-slate-900">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Titulo</th>
                    <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Anio</th>
                    <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Tipo</th>
                    <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Citas</th>
                    <th className="px-4 py-3 text-center text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Cuartil</th>
                    <th className="px-4 py-3 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Acciones</th>
                  </tr>
                </thead>
                <tbody className="bg-surface-light dark:bg-surface-dark divide-y divide-border-light dark:divide-border-dark">
                  {paginatedPublicaciones.map((pub) => (
                    <tr key={pub.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                      <td className="px-4 py-4">
                        <button 
                          onClick={() => { setSelectedPublication(pub); setShowDetailModal(true); }}
                          className="text-left hover:text-primary transition-colors"
                        >
                          <div className="text-sm font-medium text-slate-900 dark:text-white max-w-xs truncate" title={pub.titulo}>
                            {pub.titulo}
                          </div>
                        </button>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200">
                          {pub.anio}
                        </span>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        {pub.tipo && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300">
                            {pub.tipo}
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-1">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
                            <span className="material-icons-round text-xs mr-1">format_quote</span>
                            {pub.citations_count || 0}
                          </span>
                          {pub.is_top_10_percent && (
                            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200" title="Top 10% mas citados">
                              TOP
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-center">
                        {pub.cuartil ? (
                          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-bold ${
                            pub.cuartil === 'Q1' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300' :
                            pub.cuartil === 'Q2' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300' :
                            pub.cuartil === 'Q3' ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300' :
                            pub.cuartil === 'Q4' ? 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300' :
                            'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-400'
                          }`}>
                            {pub.cuartil}
                          </span>
                        ) : (
                          <span className="text-slate-400 text-xs">-</span>
                        )}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <div className="flex justify-end space-x-2">
                          <button 
                            onClick={() => { setSelectedPublication(pub); setShowDetailModal(true); }}
                            className="text-blue-500 hover:text-blue-700 dark:hover:text-blue-400 bg-blue-100 dark:bg-blue-900/20 p-1.5 rounded-md transition-colors"
                            title="Ver detalles"
                          >
                            <span className="material-icons-round text-lg">visibility</span>
                          </button>
                          {canCreateEdit() && (
                            <>
                              <button
                                onClick={() => handleRefreshPublication(pub)}
                                disabled={refreshingPublicationId === pub.id}
                                className="bg-[#edf4ff] p-1.5 rounded-md text-[#0f62fe] transition-colors hover:bg-[#dbeafe] disabled:opacity-60 dark:bg-blue-900/20 dark:text-blue-300"
                                title="Actualizar metadatos"
                              >
                                <span className={`material-icons-round text-lg ${refreshingPublicationId === pub.id ? 'animate-spin' : ''}`}>sync</span>
                              </button>
                              <button
                                onClick={() => handleAnalyzeOds(pub)}
                                disabled={analyzingOdsPublicationId === pub.id}
                                className="bg-violet-100 p-1.5 rounded-md text-violet-700 transition-colors hover:bg-violet-200 disabled:opacity-60 dark:bg-violet-900/20 dark:text-violet-300"
                                title="Comparar ODS"
                              >
                                <span className={`material-icons-round text-lg ${analyzingOdsPublicationId === pub.id ? 'animate-spin' : ''}`}>psychology_alt</span>
                              </button>
                              <button 
                                onClick={() => handleEdit(pub)}
                                className="text-amber-500 hover:text-amber-700 dark:hover:text-amber-400 bg-amber-100 dark:bg-amber-900/20 p-1.5 rounded-md transition-colors"
                                title="Editar"
                              >
                                <span className="material-icons-round text-lg">edit</span>
                              </button>
                              <button 
                                onClick={() => handleDelete(pub.id)}
                                className="text-rose-500 hover:text-rose-700 dark:hover:text-rose-400 bg-rose-100 dark:bg-rose-900/20 p-1.5 rounded-md transition-colors"
                                title="Eliminar"
                              >
                                <span className="material-icons-round text-lg">delete</span>
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </>
          )}
        </section>

        {/* Paginacion */}
        {totalPages > 1 && (
          <div className="flex justify-center">
            <nav className="relative z-0 inline-flex flex-wrap justify-center rounded-md shadow-sm">
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-border-light dark:border-border-dark bg-white dark:bg-slate-800 text-sm font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-50"
              >
                <span className="material-icons-round text-base">first_page</span>
              </button>
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className="relative inline-flex items-center px-2 py-2 border border-border-light dark:border-border-dark bg-white dark:bg-slate-800 text-sm font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-50"
              >
                <span className="material-icons-round text-base">chevron_left</span>
              </button>
              <span className="relative inline-flex items-center px-4 py-2 border border-border-light dark:border-border-dark bg-white dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-300">
                Pagina {currentPage} de {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                className="relative inline-flex items-center px-2 py-2 border border-border-light dark:border-border-dark bg-white dark:bg-slate-800 text-sm font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-50"
              >
                <span className="material-icons-round text-base">chevron_right</span>
              </button>
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-border-light dark:border-border-dark bg-white dark:bg-slate-800 text-sm font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-50"
              >
                <span className="material-icons-round text-base">last_page</span>
              </button>
            </nav>
          </div>
        )}
      </div>

      {/* Modal para formulario */}
      {showFormModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-4 sm:top-10 mx-auto p-4 sm:p-5 border w-[95%] sm:w-11/12 md:w-3/4 lg:w-2/3 xl:w-1/2 shadow-lg rounded-md bg-white dark:bg-slate-800 max-h-[92vh] overflow-y-auto">
            <div className="flex items-start justify-between gap-3 p-4 border-b">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
                <span className="material-icons-round mr-2">{isEditing ? 'edit' : 'add'}</span>
                {isEditing ? 'Editar Publicacion' : 'Nueva Publicacion'}
              </h3>
              <button
                onClick={() => setShowFormModal(false)}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <span className="material-icons-round">close</span>
              </button>
            </div>
            <div className="p-4">
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Titulo */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Titulo *</label>
                  <input
                    type="text"
                    name="titulo"
                    value={newPublicacion.titulo}
                    onChange={handleInputChange}
                    required
                    placeholder="Ingrese el titulo de la publicacion"
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                  />
                </div>

                {/* Anio, Tipo, Idioma */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Anio</label>
                    <input
                      type="number"
                      name="anio"
                      value={newPublicacion.anio}
                      onChange={handleInputChange}
                      placeholder="2024"
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo</label>
                    <select
                      name="tipo"
                      value={newPublicacion.tipo}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    >
                      <option value="">Seleccione tipo</option>
                      <option value="article">Article</option>
                      <option value="book-chapter">Book Chapter</option>
                      <option value="conference-paper">Conference Paper</option>
                      <option value="review">Review</option>
                      <option value="book">Book</option>
                      <option value="dataset">Dataset</option>
                      <option value="preprint">Preprint</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Idioma</label>
                    <select
                      name="language"
                      value={newPublicacion.language}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    >
                      <option value="">Seleccione idioma</option>
                      <option value="en">English</option>
                      <option value="es">Espanol</option>
                      <option value="pt">Portugues</option>
                      <option value="fr">Frances</option>
                      <option value="de">Deutsch</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                {/* Journal y Publisher */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Revista/Journal</label>
                    <input
                      type="text"
                      name="journal"
                      value={newPublicacion.journal}
                      onChange={handleInputChange}
                      placeholder="Nombre de la revista"
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Editorial/Publisher</label>
                    <input
                      type="text"
                      name="publisher"
                      value={newPublicacion.publisher}
                      onChange={handleInputChange}
                      placeholder="Springer, Elsevier, etc."
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                </div>

                {/* Volume, Issue, Citas */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Volumen</label>
                    <input
                      type="text"
                      name="volume"
                      value={newPublicacion.volume}
                      onChange={handleInputChange}
                      placeholder="Vol. 12"
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Numero/Issue</label>
                    <input
                      type="text"
                      name="issue"
                      value={newPublicacion.issue}
                      onChange={handleInputChange}
                      placeholder="No. 3"
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Citas</label>
                    <input
                      type="number"
                      name="citations_count"
                      value={newPublicacion.citations_count}
                      onChange={handleInputChange}
                      placeholder="0"
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                </div>

                {/* DOI y Open Access */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">DOI</label>
                    <input
                      type="text"
                      name="doi"
                      value={newPublicacion.doi}
                      onChange={handleInputChange}
                      placeholder="10.1000/ejemplo"
                      className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Open Access</label>
                    <div className="flex items-center gap-4 mt-2">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          name="is_open_access"
                          checked={newPublicacion.is_open_access}
                          onChange={(e) => setNewPublicacion({...newPublicacion, is_open_access: e.target.checked})}
                          className="w-4 h-4 text-primary bg-slate-100 border-slate-300 rounded focus:ring-primary"
                        />
                        <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">Es Open Access</span>
                      </label>
                      {newPublicacion.is_open_access && (
                        <select
                          name="oa_status"
                          value={newPublicacion.oa_status}
                          onChange={handleInputChange}
                          className="px-2 py-1 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white"
                        >
                          <option value="">Tipo OA</option>
                          <option value="gold">Gold</option>
                          <option value="green">Green</option>
                          <option value="hybrid">Hybrid</option>
                          <option value="bronze">Bronze</option>
                        </select>
                      )}
                    </div>
                  </div>
                </div>

                {/* Keywords */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Keywords (separados por comas)</label>
                  <input
                    type="text"
                    name="keywords"
                    value={newPublicacion.keywords}
                    onChange={handleInputChange}
                    placeholder="machine learning, deep learning, AI"
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                  />
                </div>

                {/* Abstract */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Abstract</label>
                  <textarea
                    name="abstract"
                    value={newPublicacion.abstract}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Resumen de la publicacion..."
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                  />
                </div>

                {/* Investigador */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Investigador *</label>
                  <select
                    name="investigador_id"
                    value={newPublicacion.investigador_id}
                    onChange={handleInputChange}
                    required
                    className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:ring-primary focus:border-primary"
                  >
                    <option value="">Seleccione un investigador</option>
                    {investigadores.map((inv) => (
                      <option key={inv.id} value={inv.id}>
                        {inv.nombre}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Botones */}
                <div className="flex justify-end space-x-3 pt-4">
                  <button 
                    type="button" 
                    onClick={() => setShowFormModal(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
                  >
                    Cancelar
                  </button>
                  <button 
                    type="submit"
                    className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-blue-600 transition-colors"
                  >
                    <span className="material-icons-round text-sm mr-2">{isEditing ? 'save' : 'add'}</span>
                    {isEditing ? 'Actualizar' : 'Agregar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Detalle de Publicacion */}
      <AnimatePresence>
        {showDetailModal && selectedPublication && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden"
            >
              {/* Header */}
              <div className="p-6 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-primary/10 to-secondary/10 dark:from-primary/20 dark:to-secondary/20">
                <div className="flex items-start justify-between">
                  <div className="flex-1 pr-4">
                    <h3 className="text-xl font-bold text-slate-900 dark:text-white leading-tight">
                      {selectedPublication.titulo}
                    </h3>
                    <div className="flex flex-wrap gap-2 mt-3">
                      {selectedPublication.anio && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200">
                          <span className="material-icons-round text-xs mr-1">calendar_today</span>
                          {selectedPublication.anio}
                        </span>
                      )}
                      {selectedPublication.tipo && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-200">
                          {selectedPublication.tipo}
                        </span>
                      )}
                      {selectedPublication.source && (
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          selectedPublication.source === 'openAlex' ? 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300' :
                          'bg-gray-100 text-gray-700 dark:bg-gray-900/40 dark:text-gray-300'
                        }`}>
                          {selectedPublication.source}
                        </span>
                      )}
                      {selectedPublication.is_retracted && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300">
                          <span className="material-icons-round text-xs mr-1">warning</span>
                          RETRACTED
                        </span>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={() => setShowDetailModal(false)}
                    className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
                  >
                    <span className="material-icons-round">close</span>
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)] space-y-6">
                {/* Metricas principales */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-amber-600 dark:text-amber-400">
                      {selectedPublication.citations_count || 0}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">Citas</div>
                    {selectedPublication.is_top_10_percent && (
                      <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200 mt-1">
                        TOP 10%
                      </span>
                    )}
                  </div>
                  <div className={`rounded-lg p-4 text-center ${
                    selectedPublication.cuartil === 'Q1' ? 'bg-emerald-50 dark:bg-emerald-900/20' :
                    selectedPublication.cuartil === 'Q2' ? 'bg-blue-50 dark:bg-blue-900/20' :
                    selectedPublication.cuartil === 'Q3' ? 'bg-amber-50 dark:bg-amber-900/20' :
                    selectedPublication.cuartil === 'Q4' ? 'bg-rose-50 dark:bg-rose-900/20' :
                    'bg-slate-50 dark:bg-slate-700/50'
                  }`}>
                    <div className={`text-2xl font-bold ${
                      selectedPublication.cuartil === 'Q1' ? 'text-emerald-600 dark:text-emerald-400' :
                      selectedPublication.cuartil === 'Q2' ? 'text-blue-600 dark:text-blue-400' :
                      selectedPublication.cuartil === 'Q3' ? 'text-amber-600 dark:text-amber-400' :
                      selectedPublication.cuartil === 'Q4' ? 'text-rose-600 dark:text-rose-400' :
                      'text-slate-400'
                    }`}>
                      {selectedPublication.cuartil || '-'}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">Cuartil</div>
                  </div>
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4 text-center">
                    <div className={`text-2xl font-bold ${selectedPublication.is_open_access ? 'text-green-600 dark:text-green-400' : 'text-slate-400'}`}>
                      {selectedPublication.is_open_access ? (
                        <span className="material-icons-round">lock_open</span>
                      ) : (
                        <span className="material-icons-round">lock</span>
                      )}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                      {selectedPublication.is_open_access ? (selectedPublication.oa_status || 'Open Access') : 'Acceso Cerrado'}
                    </div>
                  </div>
                  {(selectedPublication.fwci !== null && selectedPublication.fwci !== undefined) && (
                    <div className={`rounded-lg p-4 text-center ${
                      selectedPublication.fwci > 1 
                        ? 'bg-emerald-50 dark:bg-emerald-900/20' 
                        : selectedPublication.fwci === 0 
                          ? 'bg-slate-50 dark:bg-slate-700/50'
                          : 'bg-amber-50 dark:bg-amber-900/20'
                    }`}>
                      <div className={`text-2xl font-bold ${
                        selectedPublication.fwci > 1 
                          ? 'text-emerald-600 dark:text-emerald-400' 
                          : selectedPublication.fwci === 0 
                            ? 'text-slate-600 dark:text-slate-400'
                            : 'text-amber-600 dark:text-amber-400'
                      }`}>
                        {selectedPublication.fwci.toFixed(2)}
                      </div>
                      <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">FWCI</div>
                    </div>
                  )}
                  {selectedPublication.referenced_works_count > 0 && (
                    <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4 text-center">
                      <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
                        {selectedPublication.referenced_works_count}
                      </div>
                      <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">Referencias</div>
                    </div>
                  )}
                </div>

                {/* Informacion de la revista */}
                {(selectedPublication.journal || selectedPublication.publisher) && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 flex items-center">
                      <span className="material-icons-round text-base mr-2 text-primary">menu_book</span>
                      Informacion de la Revista
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {selectedPublication.journal && (
                        <div>
                          <span className="text-xs text-slate-500 dark:text-slate-400">Revista/Journal</span>
                          <p className="text-sm font-medium text-slate-900 dark:text-white">{selectedPublication.journal}</p>
                        </div>
                      )}
                      {selectedPublication.publisher && (
                        <div>
                          <span className="text-xs text-slate-500 dark:text-slate-400">Editorial</span>
                          <p className="text-sm font-medium text-slate-900 dark:text-white">{selectedPublication.publisher}</p>
                        </div>
                      )}
                      {selectedPublication.issn && (
                        <div>
                          <span className="text-xs text-slate-500 dark:text-slate-400">ISSN</span>
                          <p className="text-sm font-medium text-slate-900 dark:text-white">{selectedPublication.issn}</p>
                        </div>
                      )}
                      {(selectedPublication.volume || selectedPublication.issue) && (
                        <div>
                          <span className="text-xs text-slate-500 dark:text-slate-400">Volumen / Numero</span>
                          <p className="text-sm font-medium text-slate-900 dark:text-white">
                            {selectedPublication.volume && `Vol. ${selectedPublication.volume}`}
                            {selectedPublication.volume && selectedPublication.issue && ' / '}
                            {selectedPublication.issue && `No. ${selectedPublication.issue}`}
                          </p>
                        </div>
                      )}
                      {(selectedPublication.first_page || selectedPublication.last_page) && (
                        <div>
                          <span className="text-xs text-slate-500 dark:text-slate-400">Paginas</span>
                          <p className="text-sm font-medium text-slate-900 dark:text-white">
                            {selectedPublication.first_page}{selectedPublication.last_page && ` - ${selectedPublication.last_page}`}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Abstract */}
                {selectedPublication.abstract && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 flex items-center">
                      <span className="material-icons-round text-base mr-2 text-primary">description</span>
                      Abstract
                    </h4>
                    <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed whitespace-pre-wrap">
                      {selectedPublication.abstract}
                    </p>
                  </div>
                )}

                {canCreateEdit() && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4 space-y-4">
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                      <div>
                        <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 flex items-center">
                          <span className="material-icons-round text-base mr-2 text-primary">hub</span>
                          Comparacion ODS
                        </h4>
                        <p className="text-xs text-slate-500 dark:text-slate-400">
                          Compara una heuristica local frente a un analisis apoyado por IA sobre los mismos metadatos.
                        </p>
                      </div>
                      <button
                        onClick={() => handleAnalyzeOds(selectedPublication)}
                        disabled={analyzingOdsPublicationId === selectedPublication.id}
                        className="inline-flex items-center justify-center rounded-md bg-violet-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-violet-700 disabled:opacity-60"
                      >
                        <span className={`material-icons-round text-base mr-2 ${analyzingOdsPublicationId === selectedPublication.id ? 'animate-spin' : ''}`}>auto_awesome</span>
                        {analyzingOdsPublicationId === selectedPublication.id ? 'Analizando...' : 'Actualizar comparacion'}
                      </button>
                    </div>

                    {(() => {
                      const analysis = odsAnalysisByPublicationId[selectedPublication.id];
                      if (!analysis?.comparacion?.length) {
                        return (
                          <div className="rounded-xl border border-dashed border-slate-300 dark:border-slate-600 p-4 text-sm text-slate-500 dark:text-slate-400">
                            Aun no hay una comparacion guardada para esta publicacion.
                          </div>
                        );
                      }

                      return (
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                          {analysis.comparacion.map((method) => (
                            <div key={`${selectedPublication.id}-${method.metodo}`} className="rounded-xl border border-slate-200 dark:border-slate-600 bg-white/70 dark:bg-slate-800/70 p-4 space-y-3">
                              <div className="flex items-start justify-between gap-3">
                                <div>
                                  <div className="text-sm font-semibold text-slate-900 dark:text-white">
                                    {method.metodo === 'heuristica' ? 'Heuristica local' : 'Analisis IA'}
                                  </div>
                                  <div className="text-xs text-slate-500 dark:text-slate-400">
                                    {method.proveedor || 'Sin proveedor'}{method.modelo ? ` · ${method.modelo}` : ''}
                                  </div>
                                </div>
                                <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                  method.estado === 'ok'
                                    ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
                                    : method.estado === 'error'
                                      ? 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300'
                                      : 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
                                }`}>
                                  {method.estado}
                                </span>
                              </div>

                              {method.resumen && (
                                <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                                  {method.resumen}
                                </p>
                              )}

                              {method.ods?.length ? (
                                <div className="space-y-3">
                                  {method.ods.map((odsItem) => (
                                    <div key={`${method.metodo}-${odsItem.numero}`} className="rounded-lg bg-slate-50 dark:bg-slate-700/40 p-3">
                                      <div className="flex items-center justify-between gap-3">
                                        <div className="text-sm font-semibold text-slate-900 dark:text-white">
                                          ODS {odsItem.numero}: {odsItem.nombre}
                                        </div>
                                        <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                                          {Math.round((odsItem.score || 0) * 100)}%
                                        </span>
                                      </div>
                                      {odsItem.justificacion && (
                                        <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
                                          {odsItem.justificacion}
                                        </p>
                                      )}
                                      {Array.isArray(odsItem.evidencias) && odsItem.evidencias.length > 0 && (
                                        <div className="mt-2 flex flex-wrap gap-2">
                                          {odsItem.evidencias.map((evidence, idx) => (
                                            <span key={`${method.metodo}-${odsItem.numero}-${idx}`} className="inline-flex items-center rounded-md bg-slate-200 px-2 py-1 text-xs text-slate-700 dark:bg-slate-600 dark:text-slate-200">
                                              {evidence}
                                            </span>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div className="rounded-lg border border-dashed border-slate-300 dark:border-slate-600 p-3 text-sm text-slate-500 dark:text-slate-400">
                                  {method.mensaje || 'No se detecto una alineacion clara con ODS.'}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                )}

                {/* Autores */}
                {selectedPublication.authors_json && selectedPublication.authors_json.length > 0 && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 flex items-center">
                      <span className="material-icons-round text-base mr-2 text-primary">groups</span>
                      Autores ({selectedPublication.authors_json.length})
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedPublication.authors_json.map((author, idx) => (
                        <span 
                          key={idx}
                          className={`inline-flex items-center px-3 py-1.5 rounded-lg text-sm ${
                            author.position === 'first' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200 font-medium' :
                            author.position === 'last' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200 font-medium' :
                            'bg-slate-200 text-slate-700 dark:bg-slate-600 dark:text-slate-200'
                          }`}
                          title={author.position === 'first' ? 'Primer autor' : author.position === 'last' ? 'Ultimo autor' : 'Coautor'}
                        >
                          {author.name || author.display_name}
                          {author.position === 'first' && (
                            <span className="ml-1.5 text-[10px] bg-blue-200 dark:bg-blue-800 px-1 rounded">1ro</span>
                          )}
                          {author.position === 'last' && (
                            <span className="ml-1.5 text-[10px] bg-purple-200 dark:bg-purple-800 px-1 rounded">Ultimo</span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Keywords */}
                {selectedPublication.keywords && selectedPublication.keywords.length > 0 && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 flex items-center">
                      <span className="material-icons-round text-base mr-2 text-primary">label</span>
                      Keywords
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedPublication.keywords.map((kw, idx) => (
                        <span key={idx} className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-medium bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200">
                          {kw}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Conceptos */}
                {selectedPublication.concepts && selectedPublication.concepts.length > 0 && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 flex items-center">
                      <span className="material-icons-round text-base mr-2 text-primary">psychology</span>
                      Conceptos
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedPublication.concepts.map((concept, idx) => (
                        <span 
                          key={idx} 
                          className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200"
                          title={concept.score ? `Relevancia: ${(concept.score * 100).toFixed(0)}%` : ''}
                        >
                          {concept.name || concept.display_name}
                          {concept.score && (
                            <span className="ml-1.5 text-[10px] bg-emerald-200 dark:bg-emerald-800 px-1 rounded">
                              {(concept.score * 100).toFixed(0)}%
                            </span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Topics */}
                {selectedPublication.topics && selectedPublication.topics.length > 0 && (
                  <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3 flex items-center">
                      <span className="material-icons-round text-base mr-2 text-primary">topic</span>
                      Topics
                    </h4>
                    <div className="space-y-2">
                      {selectedPublication.topics.map((topic, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <span className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-medium bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-200">
                            {topic.name || topic.display_name}
                          </span>
                          {topic.field && (
                            <span className="text-xs text-slate-500 dark:text-slate-400">
                              • {topic.field}
                            </span>
                          )}
                          {topic.domain && (
                            <span className="text-xs text-slate-400 dark:text-slate-500">
                              • {topic.domain}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Enlaces */}
                <div className="flex flex-wrap gap-3">
                  {selectedPublication.doi && (
                    <a
                      href={`https://doi.org/${selectedPublication.doi}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                    >
                      <span className="material-icons-round text-base mr-2">link</span>
                      Ver en DOI
                    </a>
                  )}
                  {selectedPublication.oa_url && (
                    <a
                      href={selectedPublication.oa_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-green-600 text-white hover:bg-green-700 transition-colors"
                    >
                      <span className="material-icons-round text-base mr-2">open_in_new</span>
                      Acceso Abierto
                    </a>
                  )}
                  {selectedPublication.external_url && (
                    <a
                      href={selectedPublication.external_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-slate-600 text-white hover:bg-slate-700 transition-colors"
                    >
                      <span className="material-icons-round text-base mr-2">open_in_new</span>
                      Ver Fuente Original
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* Modal de Keywords */}
      <AnimatePresence>
        {showKeywordsModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden"
            >
              <div className="p-6 border-b border-slate-200 dark:border-slate-700">
                <div className="flex items-center justify-between">
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white">
                    Keywords Completas
                  </h3>
                  <button
                    onClick={() => setShowKeywordsModal(false)}
                    className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
                  >
                    <span className="material-icons-round">close</span>
                  </button>
                </div>
              </div>
              <div className="p-6 overflow-y-auto max-h-[60vh]">
                <div className="flex flex-wrap gap-2">
                  {selectedKeywords.map((kw, i) => (
                    <span
                      key={i}
                      className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-medium bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200"
                    >
                      {kw}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

    </>
  );
}

export default Publicaciones;


